import React, { useCallback, useState } from 'react';
import RateFeedbackQuestion from '../../FeedbackRating/RateFeedbackQuestion';
import ThanksForRating from '../../FeedbackRating/ThanksForRating';
import { useTranslation } from '../../useTranslation';
import RatingDialog from './RatingDialog';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Rating = _ref => {
  let {
    messageType,
    predictionId,
    rated,
    saveScore,
    setPredictionRated,
    setRated,
    uuid
  } = _ref;
  const [modalVisible, setModalVisible] = useState(false);
  const {
    t
  } = useTranslation();
  const submitFeedback = useCallback(body => {
    saveScore({
      body,
      params: {
        predictionId
      }
    });
    setRated(true);
    setPredictionRated(uuid);
  }, [predictionId, saveScore, setPredictionRated, setRated, uuid]);
  const handlePositiveFeedback = useCallback(() => {
    submitFeedback({
      score: 1
    });
  }, [submitFeedback]);
  const handleNegativeFeedback = useCallback(() => {
    setModalVisible(true);
  }, []);
  const handleDialogFeedback = useCallback(submittedValue => {
    submitFeedback({
      feedback: submittedValue,
      score: 0
    });
    setModalVisible(false);
  }, [submitFeedback]);
  const onClose = useCallback(() => {
    submitFeedback({
      score: 0
    });
    setModalVisible(false);
  }, [submitFeedback]);
  return ___EmotionJSX("div", {
    className: 'dc-sct-feedback__footer'
  }, rated ? ___EmotionJSX(ThanksForRating, {
    ratedMessage: t('AiAssistantRating.ratedMessage')
  }) : ___EmotionJSX(RateFeedbackQuestion, {
    messageType: messageType,
    onRateNotUseful: handleNegativeFeedback,
    onRateUseful: handlePositiveFeedback,
    question: t('AiAssistantRating.question')
  }), ___EmotionJSX(RatingDialog, {
    isOpen: modalVisible,
    onClose: onClose,
    onSubmit: handleDialogFeedback
  }));
};
export default Rating;